(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/grassroots-marketing/assets/javascripts/pages/marketing.js') >= 0) return;  svs.modules.push('/modules/grassroots-marketing/assets/javascripts/pages/marketing.js');

'use strict';

function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
const _svs$grassroots$compo = svs.grassroots.components,
  MarketingImage = _svs$grassroots$compo.MarketingImage,
  Searchbar = _svs$grassroots$compo.Searchbar;
const grassrootsQueryApi = svs.grassroots.store.grassrootsQueryApi;
const TextInput = svs.ui.reactFormInputs.TextInput;
const _React = React,
  useEffect = _React.useEffect,
  useState = _React.useState;
const Button = svs.ui.ReactButton;
const generateCode = (receiverId, shortname, imageId) => {
  if (!receiverId || !shortname || !imageId) {
    return '';
  }
  const epi = receiverId;
  const epi2 = svs.utils.url.encode(shortname);
  const receiverLink = "".concat(svs.core.urlMapping.get('grassroots.deepLinkUrl')).concat(epi, "-").concat(epi2);
  return (
    '<img src="http://clk.tradedoubler.com/click?p=23365&a=3288814&g=25342430&epi=' + epi + '&epi2=' + epi2 + '" alt="Annonsbild för gräsroten" style="display: none;">' + '<a href="http://clk.tradedoubler.com/click?p=23365&a=2176386&g=20751698&epi=' + epi + '&epi2=' + epi2 + '&url=' + receiverLink + '" target="_blank">' + '<img src="http://impse.tradedoubler.com/imp?type(img)g(' + imageId + ')a(2176386)" alt="Annonsbild för gräsroten" border=0></a>'
  );
};
const images = [{
  size: '635x350',
  tradeDoublerId: 25578030
}, {
  size: '290x290',
  tradeDoublerId: 20997286
}, {
  size: '300x250',
  tradeDoublerId: 20751698
}, {
  size: '250x250',
  tradeDoublerId: 20751692
}, {
  size: '250x120',
  tradeDoublerId: 20751682
}, {
  size: '195x150',
  tradeDoublerId: 20751670
}, {
  size: '160x160',
  tradeDoublerId: 20751628
}, {
  size: '154x260',
  tradeDoublerId: 20927774
}, {
  size: '140x140',
  tradeDoublerId: 20751624
}];
const getImageId = size => images.find(image => image.size === size).tradeDoublerId;
const Marketing = () => {
  const _useState = useState(''),
    _useState2 = _slicedToArray(_useState, 2),
    searchterm = _useState2[0],
    setSearchterm = _useState2[1];
  const _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    displayResults = _useState4[0],
    setDisplayResults = _useState4[1];
  const _useState5 = useState(null),
    _useState6 = _slicedToArray(_useState5, 2),
    receiver = _useState6[0],
    setReceiver = _useState6[1];
  const _useState7 = useState(''),
    _useState8 = _slicedToArray(_useState7, 2),
    code = _useState8[0],
    setCode = _useState8[1];
  const _useState9 = useState(''),
    _useState0 = _slicedToArray(_useState9, 2),
    activeImage = _useState0[0],
    setActiveImage = _useState0[1];
  const _grassrootsQueryApi$u = grassrootsQueryApi.useFetchReceiversSearchQuery({
      searchterm
    }),
    data = _grassrootsQueryApi$u.data;
  useEffect(() => {
    (receiver === null || receiver === void 0 ? void 0 : receiver.longname) !== searchterm && setDisplayResults(true);
  }, [searchterm]);
  useEffect(() => {
    if (receiver && activeImage) {
      setCode(generateCode(receiver.id, receiver.shortname, getImageId(activeImage)));
    }
  }, [receiver, activeImage]);
  return React.createElement("div", {
    className: "grassroots"
  }, React.createElement("div", {
    className: "marketing-container"
  }, React.createElement("section", {
    className: "form form-vertical marketing-searchbar-wrapper"
  }, React.createElement("div", {
    className: "f-content"
  }, React.createElement("h1", {
    className: "h2"
  }, "Marknadsf\xF6ringsmaterial"), React.createElement("p", null, "F\xF6r att underl\xE4tta f\xF6r er f\xF6rening att skaffa fler supportrar i Gr\xE4sroten s\xE5 kan ni h\xE4mta hem banners, affischer och annonser mm.")), React.createElement("div", {
    className: "f-content"
  }, React.createElement("div", {
    className: "f-400 f-bold"
  }, "Material"), React.createElement("a", {
    className: "js-track-marketing",
    href: "".concat(svs.core.config.data.svsconfig.cdn2, "/grassroots/grasroten_marknadsmaterial_april_2023.zip")
  }, React.createElement("span", {
    className: "f-bold f-400"
  }, "H\xE4mta marknadsf\xF6ringspaket")))), React.createElement("section", {
    className: "form form-vertical margin-xs-top-1 margin-sm-top-2"
  }, React.createElement("div", {
    className: "f-content"
  }, React.createElement("div", {
    className: "f-400 f-bold"
  }, "Banners")), React.createElement("h3", {
    className: "h3 padding marketing-h2-margin"
  }, "1. V\xE4lj f\xF6rening")), React.createElement(Searchbar, {
    displayResults: displayResults,
    onChange: e => setSearchterm(e.currentTarget.value),
    onClick: receiver => {
      setDisplayResults(false);
      setReceiver(receiver);
      setSearchterm(receiver.longname);
    },
    onSubmit: e => {
      e.preventDefault();
    },
    searchResult: data === null || data === void 0 ? void 0 : data.receivers,
    searchterm: searchterm
  }), React.createElement("section", {
    className: "form form-vertical"
  }, React.createElement("h3", {
    className: "h3 padding"
  }, "2. V\xE4lj storlek"), React.createElement("div", {
    className: "marketing-images-wrapper"
  }, images.map(image => React.createElement(MarketingImage, {
    activeImage: activeImage,
    key: image.tradeDoublerId,
    onClick: size => setActiveImage(size),
    size: image.size
  })))), React.createElement("section", {
    className: "form form-vertical padding-bottom marketing-code-wrapper"
  }, React.createElement("h3", {
    className: "h3 padding marketing-h2-margin"
  }, "3. Kopiera koden"), React.createElement(TextInput, {
    className: "marketing-code-box",
    isMultiline: true,
    label: !receiver || !activeImage ? 'Välj förening och storlek för att få en kod.' : 'Kopiera koden',
    name: "Genererad kod",
    onChange: () => {},
    value: code
  }), React.createElement(Button, {
    block: true,
    inverted: true,
    onClick: () => navigator.clipboard.writeText(code),
    size: 300
  }, "Kopiera koden till urklipp"))));
};
svs.grassroots.pages.Marketing = Marketing;

 })(window);